import * as React from "react";
const LegalIconSvg = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.3346 8.33317V12.4998C18.3346 16.6665 16.668 18.3332 12.5013 18.3332H7.5013C3.33464 18.3332 1.66797 16.6665 1.66797 12.4998V7.49984C1.66797 3.33317 3.33464 1.6665 7.5013 1.6665H11.668"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3346 8.33317H15.0013C12.5013 8.33317 11.668 7.49984 11.668 4.99984V1.6665L18.3346 8.33317Z"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83203 10.8333H10.832"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83203 14.1665H9.16536"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default LegalIconSvg;
